<!-- <div [ngClass]="getContainerClasses()">
    <div [ngClass]="
          'shrink-0 p-1.5 rounded-full ' + getIconBackgroundColorClass()
        " aria-hidden="true">
        <app-icon [name]="getIconName()" [size]="18" [class]="getIconColorClass()"></app-icon>
    </div>

    <div class="flex-1 flex flex-col gap-1.5">
        @if (title) {
        <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">
            {{ title }}
        </div>
        }
        <div class="text-sm text-gray-600 dark:text-gray-400">
            {{ message }}
        </div>

        @if (action) {
        <button class="mt-1.5 px-3 py-1.5 bg-gray-100 border border-gray-300 rounded-md text-sm font-medium text-gray-700 
                   cursor-pointer transition-colors duration-200 self-start hover:bg-gray-200 dark:bg-gray-700 
                   dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-600" (click)="action.onClick()">
            {{ action.label }}
        </button>
        }
    </div>

    @if (closable) {
    <button class="shrink-0 w-6 h-6 flex items-center justify-center border-none bg-transparent text-gray-400 
                 cursor-pointer rounded-sm text-lg leading-none transition-colors duration-200 hover:bg-gray-100 
                 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-50" (click)="handleClose()"
        aria-label="Close notification">
        <app-icon name="x" [size]="16"></app-icon>
    </button>
    } @if (duration && duration > 0) {
    <div class="absolute bottom-0 left-0 h-[3px] opacity-50 toaster-progress-bar" [ngClass]="progressColors[type]"
        [style.animation-duration.ms]="duration"></div>
    }
</div> -->

<div class="absolute inset-0 z-50 
                flex items-center justify-center 
                backdrop-blur-lg 
                rounded-2xl w-full">

    <div [ngClass]="[getBgColor()]" [ngStyle]="getBgStyle()" class="flex items-center justify-center gap-3 px-4 py-3 bg-white/90
                  rounded-[10px] shadow-sm w-full h-full">

        <!-- <div class="w-8 h-8 border-3 border-blue-500 border-t-transparent 
                    rounded-full animate-spin"></div> -->

        <span [ngStyle]="{ 'font-size': fontSize }" class="loader dark:text-white text-purple-500"></span>

        <!-- <span class="dark:text-slate-200 font-medium">
            Loading...
        </span> -->

    </div>

</div>